module.exports = __webpack_public_path__ + "media/images/flag/th-79ab0a89ce51ec151873a7bc1b8724f9.jpg";